import { NotificationsPage } from './NotificationsPage';
import { UiFeatureLite } from '@/app/feature';
import { FeatureCodes } from '@ssar-app/domain';

export const notificationsFeature: UiFeatureLite = {
  isDisabled: false,
  code: FeatureCodes.Notifications,
  rootComponent: <NotificationsPage />,
};
